import { ApiResponse, getData, postJson } from './Apis';

export type PersonalDetailsContainerModel = {
    Details: PersonalDetailsModel,
    Features: PersonalDetailsFeaturesModel,
}

export type PersonalDetailsModel = {
    Title: string,
    Forenames: string,
    Initials: string,
    Surname: string,
    Pronouns: string,
    KnownAs: string,
    EmailAddress: string,
    AlternativeEmail: string,
    HomeTel: string,
    Mobile: string,
    Nationality: string,
    NINumber: string,
    HomeAddress: string,
    Address1: string,
    Address2: string,
    Address3: string,
    City: string,
    Postcode: string,
    HomeCountry: string,
    TermAddress: string,
    TermCountry: string,
    TermTel: string,
    TermUntilMonth: string,
    TermUntilYear: string,
    PreferredName: string,
    NameInChinese: string,
}

export type PersonalDetailsFeaturesModel = {
    Agency_SendConsentConfirmationEmail: boolean,
    Admin_SendConsentConfirmationEmail: boolean,
    ShowAgencyConsultantMessage: boolean,
    PersonalDetails_TitleExamples: string,
    PersonalDetails_InitialsLabel: string,
    PersonalDetails_Initials: boolean,
    PersonalDetails_Pronouns: boolean,
    PersonalDetails_KnownAs: boolean,
    PersonalDetails_HomeAddress: boolean,
    PersonalDetails_HomeAddressSplit: boolean,
    PersonalDetails_Nationality: boolean,
    PersonalDetails_NINumber: boolean,
    PersonalDetails_TermAddress: boolean,
    PersonalDetails_AlternativeEmail: boolean,
    PersonalDetails_HomeTel: boolean,
    PersonalDetails_Mobile: boolean,
    PersonalDetails_Title: boolean,
    PersonalDetails_PreferredName: boolean,
    PersonalDetails_NameInChinese: boolean,
    PersonalDetails_Postcode: boolean,
    PersonalDetails_City: boolean,
    PersonalDetails_Country: boolean,

    PersonalDetails_Required_Address1: boolean,
    PersonalDetails_Required_City: boolean,
    PersonalDetails_Required_Postcode: boolean,
    PersonalDetails_Required_HomeCountry: boolean,
    PersonalDetails_Required_Title: boolean,
    PersonalDetails_Required_PreferredName: boolean,
    PersonalDetails_Required_NameInChinese: boolean,

    PersonalDetails_Required_Mobile: boolean,
    PersonalDetails_Required_HomeTel: boolean,
    PersonalDetails_Required_NINumber: boolean,
    PersonalDetails_Required_Nationality: boolean,
    PersonalDetails_Required_KnownAs: boolean,
    PersonalDetails_Required_Pronouns: boolean,
    PersonalDetails_Required_Initials: boolean,
}

export type PersonalDetailsResponseModel = {
    Errors: string[]
}

export async function API_GetDetails(aref: string): Promise<ApiResponse<PersonalDetailsContainerModel>> {
    return await getData<ApiResponse<PersonalDetailsContainerModel>>(`webapi/candidate/user/GetDetails${aref != null && aref.length > 0 ? "?aref=" + aref : ""}`);
}

export async function API_UpdateDetails(data: PersonalDetailsModel, aref: string, a: string, id: string): Promise<ApiResponse<PersonalDetailsResponseModel>> {
    let url = `webapi/candidate/user/UpdateDetails`;
    return await postJson<ApiResponse<PersonalDetailsResponseModel>>(url, {...data, aref, a, id});
}
